import React, { useState, useEffect } from "react";
import axios from "axios";
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import { useParams, useNavigate } from 'react-router-dom';
import '../../components/loader.css';

const VasChargesLogs = () => {
    const { fileId } = useParams();
    const [logs, setLogs] = useState([]);
    const [fileInfo, setFileInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                // Fetch file information
                const fileResponse = await axios.get(
                    `${exportValue.host}/${exportValue.version}/${exportValue.api}/vas_charge_files_by_id/${fileId}`,
                    { headers: exportValue.headers }
                );
                setFileInfo(fileResponse.data);

                // Fetch processing logs
                const logsResponse = await axios.get(
                    `${exportValue.host}/${exportValue.version}/${exportValue.api}/vas_charges_logs/${fileId}`,
                    { headers: exportValue.headers }
                );
                setLogs(logsResponse.data);
            } catch (error) {
                console.error('Error fetching logs:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogs();
    }, [fileId]);

    return (
        <div>
            <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

            <section className="home-section">
                <Sub_header />

                <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ color: '#333' }}>VAS Charges Processing Logs</h2>
                        <button
                            onClick={() => navigate(-1)}
                            style={{
                                backgroundColor: '#2196F3',
                                color: 'white',
                                padding: '8px 16px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Back to Uploads
                        </button>
                    </div>

                    {fileInfo && (
                        <div style={{
                            backgroundColor: '#f5f5f5',
                            padding: '15px',
                            borderRadius: '4px',
                            marginBottom: '20px'
                        }}>
                            <h3 style={{ marginBottom: '10px' }}>File Information</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
                                <div>
                                    <p><strong>File Name:</strong></p>
                                    <p>{fileInfo.originalName}</p>
                                </div>
                                <div>
                                    <p><strong>File Type:</strong></p>
                                    <p>{fileInfo.fileType}</p>
                                </div>
                                <div>
                                    <p><strong>Total Records:</strong></p>
                                    <p>{fileInfo.totalRecords}</p>
                                </div>
                                <div>
                                    <p><strong>Processed:</strong></p>
                                    <p>{fileInfo.processedRecords}</p>
                                </div>
                                <div>
                                    <p><strong>Status:</strong></p>
                                    <p style={{
                                        color: fileInfo.status === 'COMPLETED' ? 'green' :
                                            fileInfo.status === 'FAILED' ? 'red' : 'orange',
                                        fontWeight: 'bold'
                                    }}>
                                        {fileInfo.status}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <div className="loader"></div>
                            <p>Loading logs...</p>
                        </div>
                    ) : (
                        <div style={{
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            overflow: 'hidden'
                        }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>LRN/AWB</th>
                                        <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Timestamp</th>
                                        <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Message</th>
                                        <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Charges Applied</th>
                                        <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Reasons</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logs.length > 0 ? (
                                        logs.map((log, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '12px' }}>
                                                    {log.lrn && <div><strong>LRN:</strong> {log.lrn}</div>}
                                                    {log.awb && <div><strong>AWB:</strong> {log.awb}</div>}
                                                </td>
                                                <td style={{ padding: '12px' }}>
                                                    {new Date(log.timestamp).toLocaleString()}
                                                </td>
                                                <td style={{ padding: '12px' }}>{log.message}</td>
                                                <td style={{ padding: '12px' }}>
                                                    {log.charges && log.charges.length > 0 ? (
                                                        <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                            {log.charges.map((charge, i) => (
                                                                <li key={i}>
                                                                    <strong>{charge.type}:</strong> ₹{charge.amount.toFixed(2)}
                                                                    {charge.details && ` (${charge.details})`}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : 'None'}
                                                </td>
                                                <td style={{ padding: '12px' }}>
                                                    {log.reasons && log.reasons.length > 0 ? (
                                                        <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                            {log.reasons.map((reason, i) => (
                                                                <li key={i}>{reason}</li>
                                                            ))}
                                                        </ul>
                                                    ) : 'None'}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ padding: '20px', textAlign: 'center' }}>
                                                No processing logs available for this file
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default VasChargesLogs;